import { ChannelAttributionService } from '@packages/shared/core/common/services/channelAttribution/ChannelAttributionService';

export class ChannelAttributionServerService implements ChannelAttributionService {
  getUtmTags() {
    return {};
  }

  setAttributionStrategy() {
    return {};
  }
}
